import { render, staticRenderFns } from "./select-city.vue?vue&type=template&id=1df17bf4&"
import script from "./select-city.vue?vue&type=script&lang=ts&"
export * from "./select-city.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports